import React from "react";
import { Editor } from "@tinymce/tinymce-react";

interface Props {
  apiKey?: string;
  initialValue?: any;
  init?: {
    menubar: boolean;
    width: string;
    plugins: Array<string>;
    toolbar: string;
  };
  onEditorChange?: any;
  value?: any;
  isValidate?: boolean;
  min?: number;
  height?: string;
  onInit?: any;
  calledBy?: any;
}

export const EPRichTextEditor: React.FC<Props> = (
  {
    initialValue,
    value,
    min,
    onEditorChange,
    isValidate,
    onInit,
    height = "225px",
    init = {
      branding: false,
      menubar: true,
      width: "100%",
      height: "225px",
      plugins: [
        "advlist",
        "autolink",
        "lists",
        "link",
        "image",
        "charmap",
        "preview",
        "anchor",
        "searchreplace",
        "visualblocks",
        "fullscreen",
        "insertdatetime",
        "media",
        "table",
        "help",
        "wordcount",
      ],
      toolbar:
        "bold italict underline bullist numlist checklist outdent indent superscript subscript alignleft aligncenter alignright alignjustify | removeformat | a11ycheck code table help",
    },
    calledBy
  },
  // { apiKey = "rckm337bp386qcjqvgws7kwq1ime05ftubh8qw5ehxqktvxb" }
  // { apiKey = "0qoz572f3qp3c0qi2w4m6032xd3q4qah7qujqv8smb51rvkr" }
  { apiKey = "s0jtlceksce5054a8zzoa9l6icrygq2jth2i4jzmdxpsozjp" }
  // { apiKey = "dq2jkgpw93bzktr6lhd0ggogfgccz1k1qtlr66cb86b6we4i" },
) => {
  return (
    <div

      className={
        (!value && isValidate) ||
        ((value?.length <(min??300) && calledBy !== "LetterConfiguration")  && isValidate) ||
        ((value?.length > 25000 && calledBy !== "LetterConfiguration" ) && isValidate)
          ? "border border-danger"
          : ""
      }
    >
      <Editor
        apiKey={apiKey}
        value={value}
        onInit={onInit && onInit}
        init={{
          ...init,  // Spread existing init options
          height: height  // Override or pass the custom height
        }}
        onEditorChange={(content: any, editor: any) => {
          onEditorChange(content);
        }}
      />
    </div>
  );
};
